import React, { useState }  from 'react';
import { Title, LinkRef } from "../styles";
import styled from 'styled-components';

const ResearchContainer = styled.div`
  margin: 0 auto;
  font-weight: medium;
  font-size: 15px;
  color: #000;
  line-height: 1.2;
  margin-bottom: 30px;
`;

const PaperContainer = styled.article`
  margin-bottom: 20px;
`;

const LinkContainer = styled.div`
  margin-bottom: 10px;
`;

const ContentContainer = styled.div`
  margin-top: 10px;
  display: ${props => props.visible ? 'block' : 'none'};
`;

const BibText = styled.pre`
  font-size: 13px;
`;

const Paper = ({ title, authors, conference, abstract, bibtex, pdfUrl, codeLink }) => {
  const [showAbstract, setShowAbstract] = useState(false);
  const [showBibtex, setShowBibtex] = useState(false);

  const toggleSection = (section) => {
    if (section === 'abstract') {
      setShowAbstract(!showAbstract);
      setShowBibtex(false);
    } else {
      setShowBibtex(!showBibtex);
      setShowAbstract(false);
    }
  };

  return (
    <PaperContainer>
      <LinkRef href={pdfUrl} target="_blank" dangerouslySetInnerHTML={{ __html: title }}></LinkRef><br />
      <span dangerouslySetInnerHTML={{ __html: authors }} /><br />
      {conference}
      <LinkContainer>
        <LinkRef onClick={() => toggleSection('abstract')}>Abstract</LinkRef>&#160;〳
        <LinkRef onClick={() => toggleSection('bibtex')}>Bibtex</LinkRef>&#160;〳
        {codeLink && <LinkRef href={codeLink} target="_blank">Code</LinkRef>}
      </LinkContainer>
      <ContentContainer visible={showAbstract}>{abstract}</ContentContainer>
      <ContentContainer visible={showBibtex}>
        <BibText>{bibtex}</BibText>
      </ContentContainer>
    </PaperContainer>
  );
};

const Research = () => {
  const papers = [{
    title: "<b>A Statistical Analysis of Regret After Milk Consumption</b>",
    authors: "<b>Livia Murray</b>, Anne Hathaway, Miley Cyrus",
    conference: "Proceedings of the 1st Annual Symposium on Digestive Sciences (2025) [Oral]",
    abstract: "This study investigates the short- and long-term psychosocial impacts of dairy consumption in lactose-intolerant individuals. Using a mixed-methods approach, participants were exposed to controlled quantities of ice cream, cheese, and milkshakes under blinded conditions. Results demonstrate a statistically significant correlation (p < 0.0001) between dairy exposure and immediate gastrointestinal regret. Findings suggest that despite repeated adverse outcomes, participants continue to engage in high-risk dairy behavior, indicating strong hedonic bias and poor impulse control.",
    bibtex: `@inproceedings{
    murray2025milkregret,
    title={A Statistical Analysis of Regret After Milk Consumption},
    author={Livia Murray},
    booktitle={Proceedings of the 1st Annual Symposium on Digestive Sciences},
    year={2025},
    note={[Oral Presentation]},
    url={https://www.reddit.com/media?url=https%3A%2F%2Fpreview.redd.it%2Fwhy-dont-more-people-do-this-v0-sc8z0yaqmlrb1.jpg%3Fwidth%3D320%26crop%3Dsmart%26auto%3Dwebp%26s%3Dcf602ef0db246db2a4e2f52f459311eb93013341}
  }`,
        pdfUrl: "https://www.reddit.com/media?url=https%3A%2F%2Fpreview.redd.it%2Fwhy-dont-more-people-do-this-v0-sc8z0yaqmlrb1.jpg%3Fwidth%3D320%26crop%3Dsmart%26auto%3Dwebp%26s%3Dcf602ef0db246db2a4e2f52f459311eb93013341",
        codeLink: "https://imgur.com/gallery/so-much-dairy-im-asking-neighbor-to-use-his-toilet-because-mine-is-already-clogged-ka0K2nF#/t/lactose_intolerant"
      }
  ];

  return (
    <ResearchContainer>
      <section id="research">
        <Title>Research</Title>
        {papers.map((paper, index) => (
          <Paper key={index} {...paper} />
        ))}
      </section>
    </ResearchContainer>
  );
};

export default Research;